import React, { useState } from 'react';
import { 
    Box, Tabs, Tab, Typography, Paper,
    useTheme, useMediaQuery, Chip, Stack
} from '@mui/material';
import Layout from '../components/layout/Layout';
import PromptsManager from '../components/onboarding/PromptsManager';
import CityManager from '../components/onboarding/CityManager';
import CandidatesManager from '../components/onboarding/CandidatesManager';
import CodeOwnerTab from '../components/onboarding/CodeOwnerTab';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import PsychologyIcon from '@mui/icons-material/Psychology';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';

const Onboarding = () => {
    const [activeTab, setActiveTab] = useState(0);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <Layout>
            <Box sx={{ 
                width: '100%',
                maxWidth: '100%',
                overflowX: 'hidden',
                p: { xs: 1, sm: 2.5 },
                boxSizing: 'border-box'
            }}>
                {/* Header Banner */}
                <Box sx={{ 
                    mb: 3, 
                    display: 'flex', 
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: { xs: 'flex-start', sm: 'center' },
                    justifyContent: 'space-between',
                    gap: 1.5 
                }}>
                    <Box>
                        <Typography 
                            variant={isMobile ? "h5" : "h4"} 
                            sx={{ fontWeight: 800, letterSpacing: '-0.02em', color: '#0F172A' }}
                        >
                            Onboarding Management
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#64748B', mt: 0.5 }}>
                            Scout prospective candidates, manage city scan filters, review prompts, and approve promotional code owners.
                        </Typography>
                    </Box>

                    <Stack direction="row" spacing={1} sx={{ mt: { xs: 1, sm: 0 } }}>
                        <Chip 
                            label="Scout Pipeline" 
                            size="small" 
                            color="primary" 
                            sx={{ fontWeight: 700, borderRadius: 2 }} 
                        />
                        <Chip 
                            label="PostgreSQL Connected" 
                            size="small" 
                            sx={{ 
                                bgcolor: '#ECFDF5', 
                                color: '#047857', 
                                border: '1px solid #A7F3D0',
                                fontWeight: 600,
                                borderRadius: 2
                            }} 
                        />
                    </Stack>
                </Box>

                {/* Tabs bar */}
                <Paper 
                    elevation={0}
                    sx={{ 
                        width: '100%', 
                        mb: 3, 
                        p: 0.75,
                        borderRadius: 3,
                        backgroundColor: '#FFFFFF',
                        border: '1px solid #E2E8F0',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.03)'
                    }}
                >
                    <Tabs
                        value={activeTab}
                        onChange={handleTabChange}
                        variant={isMobile ? "scrollable" : "fullWidth"}
                        scrollButtons={isMobile ? "auto" : false}
                        sx={{
                            minHeight: 46,
                            '& .MuiTabs-indicator': {
                                height: 3,
                                borderRadius: '3px 3px 0 0',
                                bgcolor: 'primary.main'
                            }
                        }}
                    >
                        <Tab 
                            icon={<GroupAddIcon sx={{ fontSize: 18 }} />} 
                            iconPosition="start" 
                            label="CANDIDATES" 
                            sx={{ minHeight: 46, py: 1 }}
                        />
                        <Tab 
                            icon={<PsychologyIcon sx={{ fontSize: 18 }} />} 
                            iconPosition="start" 
                            label="PROMPTS" 
                            sx={{ minHeight: 46, py: 1 }}
                        />
                        <Tab 
                            icon={<LocationCityIcon sx={{ fontSize: 18 }} />} 
                            iconPosition="start" 
                            label="CITIES" 
                            sx={{ minHeight: 46, py: 1 }}
                        />
                        <Tab 
                            icon={<ManageAccountsIcon sx={{ fontSize: 18 }} />} 
                            iconPosition="start" 
                            label="CODE OWNER" 
                            sx={{ minHeight: 46, py: 1 }}
                        />
                    </Tabs>
                </Paper>

                {/* Tab Views */}
                {activeTab === 0 && <CandidatesManager />}
                {activeTab === 1 && <PromptsManager />}
                {activeTab === 2 && <CityManager />}
                {activeTab === 3 && <CodeOwnerTab />}
            </Box>
        </Layout>
    );
};

export default Onboarding;